<template>
  <infinite-scroll
    :disabled="fetching"
    @intersect="onLoadMore"
  >
    <div class="cards-list-container">
      <div class="cards-list-container__cards">
        <slot
          v-bind="{ cards: items }"
          name="body"
        />
      </div>

      <template v-if="!items.length">
        <div class="cards-list-container__empty-block">
          <base-empty-card />
        </div>
      </template>
    </div>
  </infinite-scroll>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import InfiniteScroll from '@/components/InfiniteScroll'

export default {
  name: 'CardsListContainer',
  components: {
    InfiniteScroll,
    BaseEmptyCard: () => import(/* webpackMode: "eager" */ '@/components/base/BaseEmptyCard.vue'),
  },
  props: {
    pagination: {
      type: Boolean,
      default: false,
    },
    fetching: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [1, 3], // not empty array, will check for length
    },
  },
  data () {
    return {
      test: true,
    }
  },
  computed: {
    ...mapState({
      isLogined: state => state.auth.loggedIn,
      // currentPage: state => state.otc.otcOrders.paginationInfo.currentPage,
    }),
    ...mapGetters('otc/otcBuySell', ['getSideData']),
    actionButtonText () {
      return this.$t(`otc.type.${this.getSideData[0].type}`)
    },
  },

  methods: {
    onLoadMore () {
      // this.$emit('load-more', this.currentPage + 1)
      this.$emit('load-more')
    },
  },
}
</script>

<style lang="scss" scoped>
.cards-list-container {
  flex: 1;
  padding-bottom: toRem(41px);

  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(3);
    color: color(main);
    width: 100%;
    text-align: center;
    min-height: toRem(100px);
  }

  &__cards {
    display: grid;
    gap: toRem(10px);

    @include bp(l) {
      grid-template-columns: repeat(2, 1fr);
    }

    & > div:not(:last-child) {
      margin-bottom: toRem(18px);
    }
  }

  &__empty-img {
    width: 100%;
    max-width: toRem(586px);
  }
}
</style>
